import {
  MotorFunnelState,
  SpecialDetail,
  WireMotorPolicy,
} from 'scenes/motor/types';
import {
  getPolicyStartDate,
  getSelectedExtras,
  getSpecialDetails,
  hasAdditionalSelectedPolicyHolders,
  isRegoKnown,
  isUnder25CoverSelected,
  isVehicleLookup,
  getPolicyIssued,
} from 'scenes/motor/selectors';
import { policyIssued } from 'scenes/common/analytics/marshaller/policy';

const insuranceHistory: {
  [key in SpecialDetail]: string;
} = {
  [SpecialDetail.LicenceCancelled]: 'licence cancelled',
  [SpecialDetail.InsuranceClaimRefused]: 'claim fefused',
  [SpecialDetail.InsurancePolicyCancelled]: 'policy cancelled',
  [SpecialDetail.DeniedPurchase]: 'denied purchase',
  [SpecialDetail.ConvictedOrFinedOrPenalised]:
    'convicted or fined or penalised',
  [SpecialDetail.None]: '',
};

export const toWirePolicy = (state: MotorFunnelState): WireMotorPolicy => {
  const selectedExtras = getSelectedExtras(state);

  return {
    optionalExtras: selectedExtras.length > 0,
    extras: selectedExtras.map((extra) => ({ name: extra })),
    regoKnown: isVehicleLookup(state) ? true : isRegoKnown(state),
    additionalHolder: hasAdditionalSelectedPolicyHolders(state),
    startDate: String(new Date(getPolicyStartDate(state)).valueOf()),
    insuranceHistory: getSpecialDetails(state).map(
      (detail) => insuranceHistory[detail]
    ),
    includeUnder25: isUnder25CoverSelected(state),
    issued: policyIssued[getPolicyIssued(state)],
  };
};
